// extracted by mini-css-extract-plugin
export default {"headingLabelDesktopPart1":"headingLabelDesktop_headingLabelDesktopPart1__PCOoT","headingLabelDesktopPart2":"headingLabelDesktop_headingLabelDesktopPart2__DRlg2"};